import React from 'react';

import { IconDoubleCaret } from '..';

/**
 * @typedef {TextDialProps}
 * @property {DropdownOption} currentOption the currently selected option
 * @property {function} onClick a click handler
 */
interface TextDialProps<V> {
    currentOption: DropdownOption<V>;
    onClick(): void;
}

/**
 * A selector that is intended to scroll through a list of Dropdown options sequentially. When
 * clicked, the next option in the list should become selected. When it reaches the end of the
 * options list, it should start over from the beginning. This behavior must be implemented by the
 * parent component.
 * @param {TextDialProps}
 */
export function TextDial<V>({
    currentOption,
    onClick,
}: TextDialProps<V>): JSX.Element {
    return (
        <button
            type="button"
            className="rounded-lg bg-quarternary-700 text-white text-xs font-semibold px-3 py-1 w-40"
            onClick={onClick}
        >
            <div className="flex justify-between items-center">
                {currentOption.label}
                <IconDoubleCaret fillColor="white" width={8} />
            </div>
        </button>
    );
}
